"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
var isEmail = function (email) {
    if (!/@/.test(email)) {
        return false;
    }
    var backportion = email.split('@').reverse()[0];
    if (backportion.length < 1) {
        return false;
    }
    if (!backportion.includes('.')) {
        return false;
    }
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
};
exports.isEmail = isEmail;
//# sourceMappingURL=validations.js.map